import * as R from 'ramda';

/**
 * sortByIndex :: Object -> Object
 */
export const sortByIndex = R.compose(
  R.reduce((acc, item) => R.merge(acc, { [item._id]: item }), {}),
  R.sortBy(R.prop('index')),
  R.values,
);



// WEBPACK FOOTER //
// ./src/utils/organizationSettings.js